/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Validation_Whitespaceonly1Inputs */

const en_common_validation_whitespaceonly1 = /** @type {(inputs: Common_Validation_Whitespaceonly1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input cannot consist only of half-width spaces`)
};

const ja_common_validation_whitespaceonly1 = /** @type {(inputs: Common_Validation_Whitespaceonly1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`半角空白のみは入力できません`)
};

/**
* | output |
* | --- |
* | "Input cannot consist only of half-width spaces" |
*
* @param {Common_Validation_Whitespaceonly1Inputs} inputs
* @param {{ locale?: "en" | "ja" }} options
* @returns {LocalizedString}
*/
const common_validation_whitespaceonly1 = /** @type {((inputs?: Common_Validation_Whitespaceonly1Inputs, options?: { locale?: "en" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Validation_Whitespaceonly1Inputs, { locale?: "en" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_validation_whitespaceonly1(inputs)
	return ja_common_validation_whitespaceonly1(inputs)
});
export { common_validation_whitespaceonly1 as "common_validation_whitespaceOnly" }